import { render, staticRenderFns } from "./mix-options.vue?vue&type=template&id=604df790&scoped=true"
import script from "./mix-options.vue?vue&type=script&lang=js"
export * from "./mix-options.vue?vue&type=script&lang=js"
import style0 from "./mix-options.vue?vue&type=style&index=0&id=604df790&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604df790",
  null
  
)

export default component.exports